










import BusinessService from '@/api/BusinessService';
import { ETutorial } from '@/models/tutorial';
import eventBus from '@/utils/eventBus';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Feedback extends Vue {
  service = new BusinessService();

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  onLink() {
    if (!this.business) {
      window.location.href = String(process.env.VUE_APP_CAMPAIGN_URL);
      return;
    }
    return this.$router.replace('/');
  }

  async created() {
    if (
      this.business &&
      this.business.showPlatformFeedback &&
      !this.isImpersonated
    ) {
      await this.service.updateBusinessFlagTutorial({
        state: false,
        flag: ETutorial.SHOW_PLATFORM_FEEDBACK
      });
      const business = {
        ...this.business,
        showPlatformFeedback: false
      };
      this.$store.dispatch('business/SET_BUSINESS_INFO', business);
    }
  }
}
